import Vue from 'vue'
import Vuex from 'vuex'
import { getURL, csv2ary, getInitData } from './api/utils'
import calcIdCtgMap from '@/db/calcId-ctg-list.json'
// import dummy from './db/item.json'
// import dummy_select from './db/dummy_select.json'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  state: {
    db: {},
    item: '',
    itemId: '',
    title: '',
    indexList: [],
    itemIdList: [],
    calcIdList: [],
    methodList: [],
    categoryGroup: [],
    categoryTitle: '',
    categoryId: '',
  },
  getters: {
    item (state) {
      return state.item
    },
    title (state) {
      return state.title
    },
    leftStyles({categoryId}, {categoryList}) {
      return (styleId) => {
        const rec = categoryList.find(({category}) => category === categoryId)
        return rec.method.filter(({id}) => id !== styleId)
      }
    },
    preId ({item, itemIdList}) {
      return itemIdList[itemIdList.indexOf(item) - 1] || ''
    },
    nextId ({item, itemIdList}) {
      return itemIdList[itemIdList.indexOf(item) + 1] || ''
    },
    styleName({categoryGroup}) {
      return (styleId) => categoryGroup.find(({id}) => id === styleId).name
    },
    pagesById (_, {idList}) {
      return (styleId) => idList(styleId).length
    },
    idList ({categoryGroup}, {styleName}) {
      return (styleId) => {
        const myName = styleName(styleId)
        return categoryGroup.filter(({name}) => name === myName).map(({id}) => id)
      }
    },
    categoryList ({methodList}) {
      const uniqCtgName = [...methodList
        .reduce((uniq, {category}) => (
          uniq.add(category)
        ), new Set())]
      return uniqCtgName
        .map(ctg => {
          const ctgGroup = methodList.filter(({category}) => ctg === category)
          const uniqName = [...ctgGroup
            .reduce((uniq, {name}) => uniq.add(name)
            , new Set())]
          return {
            category: ctg,
            title: ctgGroup[0].title,
            method: uniqName
              .map((uqname) => {
                const {name, id} = ctgGroup.find(({name}) => name === uqname)
                return { name, id }
              })
          }
        })
    }
  },
  mutations: {
    INIT (state, csv) {
      const {index, calcIds} = getInitData(csv)
      state.indexList = index
      state.itemIdList = index.reduce((list, {key}) => {
        if (list.indexOf(key) < 0) {
          list.push(key)
        }
        return list
      }, [])
      state.db = calcIds
    },
    CLEAR_ITEM (state) {
      state.item = state.itemId = state.title = ''
      state.methodList = []
    },
    SET_ITEM (state, {prefix, itemId}) {
      state.item = `${prefix}${itemId}`
      state.itemId = itemId
      state.title = state.indexList.find(({key}) => key === state.item).title
      state.calcIdList = state.db[state.itemId]
      state.methodList = calcIdCtgMap.filter(
        ({id}) => state.calcIdList.includes(id.replace(/_\d+$/, ''))
      )
    },
    SET_CURRENT_CATEGORY (state, styleId) {
      const {category: categoryId} = state.methodList.find(({id}) => id === styleId)
      state.categoryGroup = state.methodList.filter(({category}) => category === categoryId)
      state.categoryId = categoryId
      state.categoryTitle = state.categoryGroup[0].title
    }
  },
  actions: {
    async fetch ({ commit }, url) {
      await getURL(url).then(csv => {
        // commit('INIT', dummy)
        commit('INIT', csv2ary(csv))
      }).catch(err => {
        console.log(err)
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store2.js